import { Component, OnInit } from '@angular/core';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { ComponentModalConfig, ModalSize, SuiModal } from '@richardlt/ng2-semantic-ui';
import { threadId } from 'worker_threads';

interface IAffiliateTypeModal {
  companyTypeId?: string;
  companyRecords: any[];
}

@Component({
  selector: 'app-affiliate-type-modal',
  templateUrl: './affiliate-type-modal.component.html',
  styleUrls: ['./affiliate-type-modal.component.scss']
})
export class AffiliateTypeModalComponent implements OnInit {

  pending = false;
  addingNewType = false;
  success = '';
  error = '';
  companyTypeId = '';
  affiliateType = '';
  description = '';
  affiliateTypeId = '';
  isNewAffiliateType = false;
  allAffiliateTypes = [];
  affiliateTypesToChooseFrom = [];


  constructor(
    public modal: SuiModal<IAffiliateTypeModal, void, void>,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    this.companyTypeId = (
      (modal.context.companyTypeId) ?
      (modal.context.companyTypeId) :
      (modal.context.companyRecords[0] ?
        modal.context.companyRecords[0].companyTypeId : '')
    );
  }

  ngOnInit(): void {
    this.getAffiliateTypes();
  }

  getAffiliateTypes() {
    this.pending = true;
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any) => {
        this.pending = false;
        this.allAffiliateTypes = res;
        this.onSelectedCompanyTypeChanged();
        console.log(res);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    )
  }

  onSelectedCompanyTypeChanged() {
    let companyTypeIndex = this.getCompanyTypeIndex();
    this.getAffiliateTypesToChooseFrom(companyTypeIndex);
    this.affiliateTypeId = this.affiliateTypesToChooseFrom[0].optionId
  }

  getCompanyTypeIndex() {
    return this.modal.context.companyRecords.findIndex(element => (
      element.companyTypeId == this.companyTypeId
    ));
  }

  // Get only affiliate types not currently associated with the currently selected company type
  getAffiliateTypesToChooseFrom(companyTypeIndex: number) {
    if (this.modal.context.companyRecords[companyTypeIndex].companyTypeHasOwnershipTypes.length == 0) {
      this.affiliateTypesToChooseFrom = [...this.allAffiliateTypes];
    } else {
      this.affiliateTypesToChooseFrom = [];
      this.allAffiliateTypes.forEach((affiliateType: any) => {
        let notContained = true;
        this.modal.context.companyRecords[companyTypeIndex].companyTypeHasOwnershipTypes.every(
          (ownershipType: any) => {
            if (ownershipType.ownershipType == affiliateType.optionName) {
              notContained = false;
              return false;
            }
            return true;
          }
        )
        if (notContained) {
          this.affiliateTypesToChooseFrom.push(affiliateType);
        }
      })
    }
  }

  submit() {
    if (this.isNewAffiliateType || this.affiliateTypesToChooseFrom.length == 0) {
      this.addNewAffiliateType();
    } else {
      this.addAffiliateTypeToCompanyType();
    }
  }

  addNewAffiliateType() {
    this.addingNewType = true;
    this.companyOwnershipService.addOwnershipType({
      name: this.affiliateType,
      description: this.description
    }).subscribe(
      (res: any) => {
        this.affiliateTypeId = res;
        this.addAffiliateTypeToCompanyType();
      },
      (error) => {
        this.addingNewType = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    )
  }

  addAffiliateTypeToCompanyType() {
    this.addingNewType = true;
    this.companyOwnershipService.addOwnershipTypeToCompanyType({
      companyTypeId: this.companyTypeId,
      affiliateTypeId: this.affiliateTypeId
    }).subscribe(
      (res) => {
        this.addingNewType = false;
        this.companyOwnershipService.newAffiliateTypeAdded.emit();
        this.success = "Affiliate Type Added To Company Type";
        setTimeout(() => this.modal.approve(), 1000);
      },
      (error) => {
        this.addingNewType = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    )
  }
}

export class AffiliateTypeModal extends ComponentModalConfig<IAffiliateTypeModal, void, void> {
	constructor(companyTypeId: string, companyRecords: any[], size: ModalSize = ModalSize.Small) {
		super(AffiliateTypeModalComponent, { companyTypeId, companyRecords });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
